import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { CwdChartSection } from 'Components/Worksheets/MaximumDryDensityWorksheet/Shared';
import React from 'react';
import { useSelector } from 'react-redux';
import { Checkbox, Field, NumericInput, TextOutput } from '../../../../Core';
import { ListFieldSection } from '../../../../Layout';
import { IWorksheetComponent, WorksheetsResultsMessagesSection } from '../../../Core';
import { CompactiveEffort } from '../../types';
const contextCaptions = [{ path: `data.TestPortions`, caption: 'Test Portions' }];
let AsResultsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const CompactiveEffortType = useSelector(createWorksheetSelector!('Preparation.CompactiveEffort')) ?? false;
  const MaterialNotSuitableDueToOversize =
    useSelector(createWorksheetSelector!('Preparation.Screening.MaterialNotSuitableDueToOversize')) ?? false;
  const EnterMoistureCorrection = useSelector(createWorksheetSelector!('Results.EnterMoistureCorrection')) ?? false;
  const OversizePercentValue =
    useSelector(createWorksheetSelector!('Preparation.Screening.OversizePercentWet')) ?? null;
  return (
    <>
      <WorksheetsResultsMessagesSection contextCaptions={contextCaptions} />
      {/* Only render results if material is suitable for testing */}
      {!MaterialNotSuitableDueToOversize && (
        <>
          <CwdChartSection hideCurveFittingSelection={false} />
          <ListFieldSection heading="Laboratory Results">
            <Field input={<TextOutput />} name="Results.PeakConvertedWetDensity" emph />
            <Field input={<TextOutput />} name="Results.PeakMoistureIncrement" emph />
          </ListFieldSection>
          <ListFieldSection visible={CompactiveEffortType === CompactiveEffort.Modified}>
            <Field input={<Checkbox />} name="Results.EnterMoistureCorrection" />
          </ListFieldSection>
          <ListFieldSection>
            <Field
              input={<TextOutput />}
              name="Results.MoistureCorrection"
              visible={CompactiveEffortType === CompactiveEffort.Standard}
              emph
            />
            <Field
              input={<NumericInput />}
              name="Results.MoistureCorrection"
              emph
              visible={CompactiveEffortType === CompactiveEffort.Modified && EnterMoistureCorrection}
            />
            <Field
              input={<TextOutput />}
              name="Results.MoistureVariation"
              emph
              visible={
                (CompactiveEffortType === CompactiveEffort.Modified && EnterMoistureCorrection) ||
                CompactiveEffortType === CompactiveEffort.Standard
              }
            />
          </ListFieldSection>
          <ListFieldSection heading="Corrected for Oversize" visible={OversizePercentValue > 0}>
            <Field input={<TextOutput />} name="Results.AdjustedPeakConvertedWetDensity" emph />
            <Field
              input={<TextOutput />}
              name="Results.AdjustedMoistureVariation"
              emph
              visible={
                (CompactiveEffortType === CompactiveEffort.Modified && EnterMoistureCorrection) ||
                CompactiveEffortType === CompactiveEffort.Standard
              }
            />
          </ListFieldSection>
          <ListFieldSection heading="Field Results">
            <Field
              input={<TextOutput />}
              name="FieldResults.AssociatedFieldWetDensity.ExternalTest.Results.FieldWetDensity"
              emph
            />
            <Field input={<TextOutput />} name="FieldResults.FieldMoistureContent" emph />
          </ListFieldSection>
          <ListFieldSection heading="Compaction Control Results">
            <Field input={<TextOutput />} name="Results.OptimumMoistureContent" emph />
            <Field input={<TextOutput />} name="Results.SoilMoistureLevel" emph />
            <Field input={<TextOutput />} name="Results.MoistureRatio" emph />
            <Field input={<TextOutput />} name="Results.HilfDensityRatio" emph />
          </ListFieldSection>
        </>
      )}
    </>
  );
};

AsResultsSection = withInjectedProps(AsResultsSection);

export { AsResultsSection };
export default AsResultsSection;
